/* ==========================================================================
   <x-countdown>
   data-end="2026-12-31T23:59:59+03:00"  fixed end date (ISO 8601), or
   data-daily="23:59"                    resets every day at this Riyadh time
   data-expired-text="…"                 optional text when finished
   Fills .countdown__value[data-unit="days|hours|minutes|seconds"].
   ========================================================================== */
if (!customElements.get('x-countdown')) {
  customElements.define(
    'x-countdown',
    class XCountdown extends HTMLElement {
      connectedCallback() {
        this.values = {};
        this.querySelectorAll('[data-unit]').forEach((el) => (this.values[el.dataset.unit] = el));
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      get endTime() {
        if (this.dataset.daily) {
          // Riyadh is UTC+3 all year (no DST)
          const [h, m] = this.dataset.daily.split(':').map(Number);
          const now = new Date();
          const riyadhNow = new Date(now.getTime() + (now.getTimezoneOffset() + 180) * 60000);
          const end = new Date(riyadhNow);
          end.setHours(h, m || 0, 0, 0);
          if (end <= riyadhNow) end.setDate(end.getDate() + 1);
          return now.getTime() + (end - riyadhNow);
        }
        return Date.parse(this.dataset.end);
      }

      tick() {
        const end = this.endTime;
        if (Number.isNaN(end)) return;
        let diff = Math.max(0, Math.floor((end - Date.now()) / 1000));

        if (diff === 0 && !this.dataset.daily) {
          clearInterval(this.timer);
          this.setAttribute('data-expired', '');
          if (this.dataset.expiredText) this.textContent = this.dataset.expiredText;
          this.dispatchEvent(new CustomEvent('countdown:end', { bubbles: true }));
          return;
        }

        const units = {
          days: Math.floor(diff / 86400),
          hours: Math.floor((diff % 86400) / 3600),
          minutes: Math.floor((diff % 3600) / 60),
          seconds: diff % 60,
        };
        // Without a days slot, fold days into hours
        if (!this.values.days) units.hours += units.days * 24;

        Object.entries(this.values).forEach(([unit, el]) => {
          const value = String(units[unit] ?? 0).padStart(2, '0');
          if (el.textContent !== value) el.textContent = value;
        });
      }
    }
  );
}
